"use client";

import { clsx } from "@trydig/ui";
import { type PropsWithChildren, useState } from "react";
import styles from "~/features/products/ProductListingPage/ProductListingPage.module.css";

export const HeroParagraph = ({ children }: PropsWithChildren) => {
	const [expanded, setExpanded] = useState(false);

	return (
		<div className={clsx(expanded && styles.expanded, styles.heroTextWrapper)}>
			<div className={styles.heroText}>{children}</div>
			{!expanded && (
				<button
					className="transparent"
					onClick={(e) => {
						e.preventDefault();
						setExpanded(true);
					}}
				>
					Les mer
				</button>
			)}
		</div>
	);
};
